module.exports = __webpack_public_path__ + "img/flc-insta1.2cc7197a.png";